import { render, staticRenderFns } from "./ShowTableData.vue?vue&type=template&id=565b4aec&scoped=true"
import script from "./ShowTableData.vue?vue&type=script&lang=js"
export * from "./ShowTableData.vue?vue&type=script&lang=js"
import style0 from "./ShowTableData.vue?vue&type=style&index=0&id=565b4aec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b4aec",
  null
  
)

export default component.exports